module.exports = __webpack_public_path__ + "img/analysisIcon5.e99101a8.png";